import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import AuthLayout from "@/layouts/Authenticated";
import useAppStore from "@/store/appStateZustand";

export const Route = createFileRoute("/_auth")({
  beforeLoad: ({ location }) => {
    const accessToken = useAppStore.getState().authentication?.access_token as string | undefined;
    if (accessToken === undefined || accessToken.length === 0) {
      throw redirect({
        to: "/login",
        search: { redirect: location.pathname + location.searchStr },
      });
    }
  },
  component: AuthenticatedLayout,
});

function AuthenticatedLayout() {
  return (
    <AuthLayout>
      <Outlet />
    </AuthLayout>
  );
}
